export default {
    tutorial: 'Manual',
    subTutorial: 'Payment',
    problem: 'Raise a ticket',
    subProblem: 'Please specify details'
}
